// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3e-tt","vLegacy":"SelectSecondary_vLegacy__33r1G","error":"SelectSecondary_error__3YErh","disabled":"SelectSecondary_disabled__3nB1m"};